module.exports = __webpack_public_path__ + "img/small-abstract-2.2f1be76.svg";